import styles from './Spinner.module.scss';
import classNames from 'classnames';

export interface SpinnerProps {
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'primary' | 'neutral';
}

export function Spinner({
  className,
  size = 'md',
  variant = 'primary',
}: SpinnerProps) {
  return (
    <div
      className={classNames(
        styles.spinner,
        styles[`spinner--${size}`],
        styles[`spinner--${variant}`],
        className,
      )}
      role="status"
      aria-label="Loading"
    />
  );
}
